import { downloadEntries } from '@/pages/home/data';

const toneMap: Record<string, { bubble: string; badge: string; button: string }> = {
  primary: {
    bubble: 'bg-primary-100 text-primary-700',
    badge: 'bg-primary-50 text-primary-700',
    button: 'bg-primary-500 text-background-50 hover:bg-primary-600',
  },
  accent: {
    bubble: 'bg-accent-100 text-accent-800',
    badge: 'bg-accent-50 text-accent-800',
    button: 'bg-accent-500 text-foreground-950 hover:bg-accent-600',
  },
  secondary: {
    bubble: 'bg-secondary-100 text-secondary-700',
    badge: 'bg-secondary-50 text-secondary-700',
    button: 'bg-secondary-500 text-background-50 hover:bg-secondary-600',
  },
  foreground: {
    bubble: 'bg-background-200 text-foreground-800',
    badge: 'bg-background-100 text-foreground-700',
    button: 'bg-foreground-900 text-background-50 hover:bg-foreground-800',
  },
};

export default function DownloadEntries() {
  return (
    <section id="download" className="scroll-mt-20 bg-background-50">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-xs font-medium tracking-[0.24em] text-primary-600">DOWNLOAD ENTRY</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              选择适合你的下载入口
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md">
            安卓版、手机版、完整安装包与最新版本，四种获取方式对应不同使用习惯。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {downloadEntries.map((entry) => {
            const tone = toneMap[entry.tone];
            return (
              <article
                key={entry.id}
                className="flex flex-col bg-background-50 border border-background-200 rounded-xl p-5 hover:border-primary-300 transition-colors"
              >
                <span className={`w-12 h-12 rounded-lg flex items-center justify-center ${tone.bubble}`}>
                  <i className={`${entry.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">{entry.title}</h3>
                <p className="mt-1 text-sm text-foreground-500">{entry.subtitle}</p>

                <ul className="mt-4 space-y-2 flex-1">
                  {entry.meta.map((m) => (
                    <li key={m} className="flex items-center gap-2 text-xs text-foreground-600">
                      <i className="ri-check-line text-secondary-600"></i>
                      {m}
                    </li>
                  ))}
                </ul>

                <a
                  href="#top"
                  className={`mt-5 inline-flex items-center justify-center gap-1.5 h-10 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${tone.button}`}
                >
                  {entry.cta}
                  <i className="ri-arrow-right-line"></i>
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}